<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-22 10:15:08
 * @FilePath: /teacher-h5/src/demo/message.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Message 全局提示
      </h1>
      <div>
        <a-button type="primary" @click="info">
          Display normal message
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    info() {
      this.$message.info('This is a normal message', 100000)
    }
  }
}
</script>

<style>
</style>